import type { ReactNode } from 'react';
import { SidebarHeader } from '@monksflow/monks-ui';

export interface FeatureSidebarHeaderProps {
  children: ReactNode;
}

/**
 * Header slot for `FeatureSidebar`.
 *
 * Wraps the DS `SidebarHeader` primitive so this surface shares the
 * same surface tokens (padding, gap, sticky behaviour) as the main
 * app rail. Caller provides the trigger / popover content.
 */
export function FeatureSidebarHeader({ children }: FeatureSidebarHeaderProps) {
  return <SidebarHeader className="p-0">{children}</SidebarHeader>;
}
